module.exports = __webpack_public_path__ + "img/pointing-laughing-2.ba79f8c3.png";